import scriptLoader from "../fsUtils/ScriptLoader";

class Analytics {

    constructor() {

        this.isUtagLoaded = false;
        this.metaObj = this.getPageMeta();
        this.refreshRate = (this.metaObj) ? this.metaObj.refresh_rate : 0;
        this.reSendMetadata();
        this.metadataStorage = [];

        //save the first article mata data
        this.setMetadataStorage(0, this.metaObj);

    }

    /**
     * @desc On gallery angular app, we need to update analytic meta data on every image slide onScroll.
     *      this method is to pass the analytic meta data to /components/galleryPage/scripts/ads/adsService.js.
     *      we call this method on pageload to set meta data for the first story. The method will be called again
     *      on url change on 3things
     * @param i this.metadataStorage index
     * @param meta Meta object
     */
    setMetadataStorage(i, meta) {

        var analytics = {
            page_name: meta.page_name,
            page_type: meta.page_type,
            category: meta.category,
            author: meta.author,
            story_title: meta.story_title
        };

        this.metadataStorage[i] =  analytics;

    }

    getUtagLib(url, callback) {
        
        scriptLoader.getScript(url, callback, true);

    }

    loadUtagLib(url) {
        if (!this.isUtagLoaded) {
            this.getUtagLib(url, () => {
                this.isUtagLoaded = true;
            });
        }
    }

    // on page load
    sendPageView(data) {
        //get page metadata if nothing is passed
        var data = data || this.metaObj;
        this.loadUtagLib(data.utaglib_path);
        window.utag_data = data;
    }

    /**
     * get meta object from meta tag fs-prop="analytics" on the main article (first article on the 3things)
     * @returns {object} Meta Object
     */
    getPageMeta() {

        let data = {};
        let metaEl = document.querySelector('[fs-prop="analytics"]');
        let attributes = ['account', 'cms-id', 'utaglib-path', 'utags', 'page-name', 'category', 'sub-category',
            'page-type', 'page_topic', 'page-type-alias,', 'page-topic', 'user-state', 'filename', 'story-title',
            'gallery-name', 'source', 'author', 'publish-date', 'refresh-rate', 'story-position', 'hasEmbeddedGallery', 'site-name',
            'page-attribute'
        ];

        /**
         *  to enforce html semantic, we use dashes for property names.
         *  We need to do the dashes replacement with underscore since
         *  analytic script uses underscore in the properties
         */
        for (var i = 0, l = attributes.length; i < l; i++) {
            let attr = attributes[i];
            let val = metaEl.getAttribute(attr);
            if (val != null) {
                attr = (attr.indexOf('-') >= 0) ? attr.replace(/-/g, '_') : attr;
                data[attr] = val.trim();
            }
        }

        return data;
    }
    reSendMetadata() {
        if (this.refreshRate > 0) {
            setInterval(function() {
                var data = window.utag_data;
                if (data !== null || data !== undefined) {
                    this.utagView(window.utag_data);
                }
            }.bind(this), this.refreshRate * 1000);
        }
    }

    //utag api - call for any subsequent utag views
    utagView(data) {

        this.loadUtagLib(window.utag_data.utaglib_path);
        /* current data format (dont remove this yet)
		{
	        "account": "foxsports",
	        "page_name": "fscom:home:home",
	        "utags": "home|west|mlb",
	        "category": "home",
	        "page_type": "home",
	        "cms_id": "12121",
	        "page_topic": "classes:fsdigital/fscom/Home,classes:fsdigital/fscom/local/west/top-headlines,classes:fsdigital/fscom/local/west,internal:components/buzzer/mlb",
	        "filename": "http://www.foxsports.com/home",
	        "user_state": "", 
	        "analyticsRefreshRate": "0"
	    }
		*/

        try {
            if(typeof utag !== 'undefined') {
                utag.view(data);
            }
        } catch (e) {
            console.log(e);
            throw new Error("ANALYTICS !! - something went wrong calling utag.view");
        }


    }

    //event and link tracking
    utagLink(data) {
        data.test = "fb-click";

        try {
            utag.link(data);
        } catch (e) {
            throw new Error("ANALYTICS !! - something went wrong calling utag.link");
        }
    }

    sendEventView(data) {
        this.utagLink(data);
    }

}

export default new Analytics();


// WEBPACK FOOTER //
// ./assets/components/analytics/Analytics.js